import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Sidebar from '../components/sidebar';
import Navbar from '../components/navbar';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="bg-gray-100">
      <Helmet>
        <title>My Account | AfricFresh</title>
        <meta name="description" content="Manage your AfricFresh account, orders, and preferences" />
      </Helmet>
      
      <div className="flex-1 flex flex-col transition-all duration-300">
        <Navbar toggleSidebar={toggleSidebar} />
        
        <main className="flex p-6 max-sm:p-2 mt-20 max-sm:mt-0 overflow-y-auto ml-32 max-sm:ml-0">
          <Sidebar isOpen={isSidebarOpen} />
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;